import { render, staticRenderFns } from "./AsiDialogAvatarUpload.vue?vue&type=template&id=074dcdec&scoped=true"
import script from "./AsiDialogAvatarUpload.vue?vue&type=script&lang=ts"
export * from "./AsiDialogAvatarUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074dcdec",
  null
  
)

export default component.exports